export const FETCH_WITHDRAWL_LIST = 'withdrawal/FETCH_WITHDRAWL_LIST';
export const FETCH_WITHDRAWL_INFO = 'withdrawal/FETCH_WITHDRAWL_INFO';
export const WITHDRAW_BY_BANK = 'withdrawal/WITHDRAW_BY_BANK';



// WEBPACK FOOTER //
// ./src/app/redux/front/withdrawal/types.js